// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Wzhv","title":"Info_title__MO4Hw","selects":"Info_selects__3cnPP","requiredAsterisk":"Info_requiredAsterisk__3yzYs"};